export default "__VITE_ASSET__MiOHOy$D__"